<div class="slider">
    <ng5-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options"
        (valueChange)="onPriceMinChange($event)" (highValueChange)="onPriceMaxChange($event)"></ng5-slider>
</div>